// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__q47ZA","title":"Header_title__3VFnb","left":"Header_left__2BAz2","clinicName":"Header_clinicName__ktFhW"};